window.ajaxWaitTimer = null;

(function () {
	jQuery.ajaxWait = function (options) {
		if (ajaxWaitTimer != null)
			return;

		let opts = jQuery.extend({}, jQuery.ajaxWait.defaults, options);

		let $box = null;

		ajaxWaitTimer = setTimeout(function () {
			alertify.modalblock('');
		}, opts.waitInterval);
	}
	jQuery.ajaxWait.defaults = {
		container: null,
		waitInterval: 2000
	};

	jQuery.ajaxWaitOver = function () {
		if (ajaxWaitTimer) {
			clearTimeout(ajaxWaitTimer);

			alertify.modalblock().close();

			ajaxWaitTimer = null;
		}
	}
})(jQuery);

(function () {
	//--replacement for deprecated jquery trim
	//--handles null/undefined values where String.prototype does not.
	jQuery.trim2 = function (val) {
		return (null == val ? "" : (val + "").replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, ""));
	}
})(jQuery);

(function ($) {
	jQuery.fn.numericOnly = function (opts) {
		let defaults = {
			allowDecimal: false,
			allowNegative: false,
			allowPaste: true
		};

		let options = $.extend({}, defaults, opts);
		let regex = /^[0-9]+$/;

		if (options.allowPaste) {
			if (options.allowDecimal && options.allowNegative) {
				regex = /^-?[0-9]+(\.[0-9]+)?$/;
			} else if (!options.allowDecimal && options.allowNegative) {
				regex = /^-?[0-9]+$/;
			} else if (options.allowDecimal && !options.allowNegative) {
				regex = /^[0-9]+(\.[0-9]+)?$/;
			}
		}

		return this.each(function () {
			$(this).on("keydown", function (event) {
				if (options.allowPaste && event.ctrlKey) {
					return true;
				}

				if (event.keyCode == 46 || event.keyCode == 8 || event.keyCode == 9
					|| event.keyCode == 27 || event.keyCode == 13 || (options.allowDecimal && (event.keyCode == 110 || event.keyCode == 190) || (options.allowNegative && (event.keyCode == 109 || event.keyCode == 189)))
					||
					(event.keyCode == 65 && event.ctrlKey === true)
					|| (event.keyCode >= 35 && event.keyCode <= 39)
				) {
					return;
				} else {
					// If it's not a number stop the keypress
					if (event.shiftKey || (event.keyCode < 48 || event.keyCode > 57) && (event.keyCode < 96 || event.keyCode > 105)) {
						event.preventDefault();
					}
				}
			}).on("paste", function (e) {
				let pasteData = e.originalEvent.clipboardData.getData('text');
				if (!regex.test(pasteData))
					e.preventDefault();
			});
		});
	};
})(jQuery);

(function ($) {
	jQuery.fn.restrictMaxLength = function (options) {
		return this.each(function () {
			let $this = $(this);
			let opts = jQuery.extend({}, jQuery.fn.restrictMaxLength.defaults, options);

			if ($this.data('wired') === "1")
				return;
			else
				$this.data('wired', "1")

			let lbl = $(this).data('chars-remaining-label');
			let len = $(this).data('rule-maxlength');
			let serverSideLineFee = $this.data("serversidelinebreaks");

			if (serverSideLineFee === undefined)
				serverSideLineFee = opts.serverSideLineFeed;

			if (len === undefined) {
				len = opts.maxlength;
			}

			if (len == null)
				len = $this.attr('maxlength');

			if (len == null)
				len = 1;

			if (lbl == undefined)
				lbl = opts.label;

			if (lbl == null && this.id != undefined)
				lbl = this.id + '-remaining';

			if (lbl == null)
				return;

			let $lbl = $('#' + lbl);

			if ($lbl.length == 0)
				return;

			setRemaining($this, $lbl, len);

			$this.on("keyup", function () {
				setRemaining($this, $lbl, len);
			});

			$this.on('input propertychange', function () {
				let val = $this.val();
				if (getServerSaysLength(val, serverSideLineFee) > len) {
					$this.val(val.substring(0, len));
				}
			});

			function setRemaining($el, $lbl, maxlen) {
				let length = getServerSaysLength($el.val(), serverSideLineFee);

				let remaining = maxlen - length;

				$lbl.html(remaining + ' characters remaining');

				if (opts.onSetRemaining) {
					opts.onSetRemaining($el, $lbl, remaining);
				}
			}

			function getServerSaysLength(value, serverSideLineFee) {
				if (!serverSideLineFee)
					return value.length;

				/* count line feeds as 2 bc server side does */
				var replaced = value.replace(/(\n)/g, '##');
				return replaced.length;
			}
		});
	};
	jQuery.fn.restrictMaxLength.defaults = {
		maxlength: null,
		label: null,
		onSetRemaining: null,
		serverSideLineFeed: true
	};
})(jQuery);

(function ($) {
	$.fn.initialFocus = function () {
		$(this).each(function () {
			$('input[type!=hidden]:first', $(this)).trigger("focus");
		});
	};
})(jQuery);

(function ($, window, document) {
	"use strict";
	$.fn.formprompt = function (options) {
		return this.each(function () {
			let opts = jQuery.extend({}, jQuery.fn.formprompt.defaults, options);

			let originals = '',
				$form = $(this),
				$win = $(window),
				$doc = $(document),
				prompt = false;

			$doc.on('click', 'body', function (e) {
				let $target = $(e.target);
				prompt = true;

				if ($target.is(opts.excludeselector) || $target.data('noprompt') == "1")
					prompt = false;
			});

			$form.on('submit', function () {
				prompt = false;
			});

			function extractFormData() {
				let formdata = $form.serialize();
				$form.find('input[type=file]').each(function () {
					formdata = formdata + $(this).val();
				});
				return formdata;
			}

			function saveOriginals() {
				originals = extractFormData();
			}

			function savePrompt(e) {
				let current = extractFormData();
				if (current !== originals && prompt) {
					e.preventDefault();
					prompt = true;
					return opts.msg;
				}
			}

			$doc.ready(saveOriginals);              // Saving original state of the form once the document is loaded
			$win.on('beforeunload', savePrompt);  // Function call here to check if the form has changed
		});
	};

	jQuery.fn.formprompt.defaults = {
		msg: 'There are unsaved changes on this form',
		excludeselector: '.noprompt'
	};
})(jQuery, window, document);

$(function () {
	$('table.mnw-resp-card-table-sm, table.mnw-resp-card-table-md, table.mnw-resp-card-table-lg, table.mnw-resp-card-table-xl').each(function () {
		$(this).cardtable();
	});
});

(function ($) {
	$.fn.cardtable = function () {
		let $table = $(this);
		if ($table.length > 0 && !$table.is('table'))
			throw 'Not a table';

		$table.find('thead > tr > th').each(function (index) {
				let $th = $(this);
				let title = $th.html();

				if ($th.attr('data-title'))
					title = $th.attr('data-title');

				title = title.replace('&nbsp;', '');

				$('tbody > tr > td:nth-child(' + (index + 1) + ')', $table).each(function (e) {
					let $this = $(this);
					let hasatt = $this.attr('data-title') !== undefined;

					if (!hasatt)
						$this.attr('data-title', title);
				});
			}
		);

		$table.find('td').each(function (index) {
				let $td = $(this);
				let content = $td.html();

				if (content.trim() == '')
					$td.html('&nbsp');
			}
		);
	};
})(jQuery);

(function ($) {
	$.fn.disableIframeContent = function () {
		let $this = $(this);

		$this.each(function () {
			let $contents = $(this).contents();

			$contents.find('body a, body button, body input[type="button"], body input[type="submit"]').on('click', function (e) {
				e.preventDefault();
			})

			$contents.find('body input[type="text"]').each(function (e) {
				$(this).prop('autocomplete', 'off');
			});

			$contents.find('body button, body input[type="button"], body input[type="submit"]').each(function (e) {
				$(this).prop('disabled', 'disabled');
			});

			$contents.find('body .g-recaptcha').css('display', 'none');
		});

		return $this;
	};
})(jQuery);

(function ($) {
	$.fn.writeIframeContent = function (content, autoheight) {
		let $this = $(this);

		$this.each(function () {
			let frm = this;
			let doc = frm.contentWindow.document;
			doc.open();
			try {
				doc.write(content);

				if (autoheight === true) {
					frm.height = frm.contentWindow.document.body.scrollHeight;
				}

			} catch (e) {
				doc.write('<html><head><title></title></head><body>Error</body></html>');
			}
			doc.close();
		});

		return $this;
	};
})(jQuery);

(function () {
	jQuery.togglePasswordFields = function ($btn) {
		let classname = $btn.data('toggleclass');
		let $passwords = $('.' + classname);

		let label = 'Password';

		if ($passwords.length > 1)
			label = 'Passwords';

		$passwords.each(function () {
			let pass = this;

			if (pass.type === "password") {
				pass.type = "text";
				$btn.text('Hide ' + label);
			} else {
				pass.type = "password";
				$btn.text('Show ' + label);
			}
		});
	}
})(jQuery);

(function ($) {
	$.fn.collapsible = function (options) {
		if (options === undefined)
			options = {};

		return $(this).each(function () {
			var $this = $(this);

			if (options.stopselector) {
				$(options.stopselector, $this).on('click', e => {
					e.stopPropagation()
				});
			}

			$this.on("click", function (e) {
				var id = $this.data('collapse');
				var $pnl = $('#' + id);
				var state = true;

				if ($pnl.is(':visible')) {
					$pnl.slideUp('fast', function () {
						$('i', $this).html('keyboard_arrow_down');
					});
				} else {
					$pnl.slideDown('fast', function () {
						$('i', $this).html('keyboard_arrow_up');
					});
					state = false;
				}
				e.preventDefault();

				if (options && options.callback)
					options.callback($this, state)
			});

		});
	}
})(jQuery);

(function ($) {
	$.fn.disableOnSubmit = function () {
		$(this).each(function () {
			var $frm = $(this);
			let set = $frm.data('disable-set');

			if (set === undefined)
				$frm.data('disable-set', '1');
			else
				return;

			let legacy = $frm.data('mnw-disable') === 'legacy';

			if (jQuery().validate && !legacy) {
				/*hook in via the unobtrusive wrapper */
				$frm.validate().settings.submitHandler = function (frm) {
					if ($frm.data('submitted') == true)
						return false;

					$frm.data('submitted', true);
					frm.submit();

					window.setTimeout(function () {
						$('input[type="submit"], button[type="submit"]', $frm).attr('disabled', 'disabled');
					}, 200);
				};
			} else {
				$frm.on("submit", function () {
					if ($frm.data('submitted') == true)
						return false;

					//--jquery validate still wires up maxlength
					if (jQuery().validate && !$frm.valid())
						return false;

					window.setTimeout(function () {
						$('input[type="submit"], button[type="submit"]', $frm).attr('disabled', 'disabled');
					}, 200);

					$frm.data('submitted', true);
				})
			}
		});
	};
})(jQuery);

(function ($) {
	$.fn.disableSubmit = function () {
		$(this).each(function () {
			$('input[type="submit"], button[type="submit"]', $(this)).attr('disabled', 'disabled');
		});
	};
})(jQuery);